module.exports = __webpack_public_path__ + "img/space-ship.fb505b29.gif";